import { IOrderPaymentDto } from '../interface/IOrderPaymentDto'
import {
  PaymentMethod,
  ChargeType,
  OrderPaymentType,
  PaymentProvider,
  OrderPaymentStatus
} from '@/types/enum/OrderEnum'
export const OrderPaymentDto: IOrderPaymentDto = {
  id: '',
  createdDate: '',
  orderId: '',
  paymentMethod: PaymentMethod.CreditCard,
  chargeType: ChargeType.Authorize,
  paymentType: OrderPaymentType.Void,
  paymentProvider: PaymentProvider.Stripe,
  transactionId: '',
  settlementAmount: 0,
  status: OrderPaymentStatus.Failed,
  errors: ''
}
